import { Table } from "reactstrap";
import { H4, LI, UL } from "../../../../../AbstractElements";
import { InvoiceThreeData } from "../../../../../Data/Applications/ECommerce/ECommerce";

const InvoiceTable = () => {
  return (
    <tr>
      <td className="p-0">
        <Table borderless style={{ width: "100%", borderSpacing: 0 }}>
          <thead>
            <tr style={{ background: "#2A5699" }}>
              <th style={{ padding: "18px 15px", textAlign: "left" }}>
                <span style={{ color: "#fff", fontSize: 18, fontWeight: 600 }}>Description</span>
              </th>
              <th style={{ padding: "18px 15px", textAlign: "center", borderInline: "3px solid #fff" }}>
                <span style={{ color: "#fff", fontSize: 18, fontWeight: 600 }}>Qty</span>
              </th>
              <th style={{ padding: "18px 15px", textAlign: "center", borderRight: "3px solid #fff" }}>
                <span style={{ color: "#fff", fontSize: 18, fontWeight: 600 }}>Price</span>
              </th>
              <th style={{ padding: "18px 15px", textAlign: "center" }}>
                <span style={{ color: "#fff", fontSize: 18, fontWeight: 600 }}>Subtotal</span>
              </th>
            </tr>
          </thead>
          <tbody>
            {InvoiceThreeData.map((data, i) => (
              <tr key={i}>
                <td style={{ padding: "18px 15px 18px 0", display: "flex", alignItems: "center", gap: 10, borderBottom: "1px solid #52526C4D" }}>
                  <span style={{ width: 3, height: 37, backgroundColor: `${data.color}` }} />
                  <UL style={{ padding: 0, margin: 0, listStyle: "none" }} className="simple-list">
                    <LI>
                      <H4 style={{ fontWeight: 600, margin: "4px 0px", fontSize: 18, color: "#2A5699" }}>{data.title}</H4>
                      <span style={{ opacity: "0.8", fontSize: 16 }}>{data.detail}</span>
                    </LI>
                  </UL>
                </td>
                <td style={{ padding: "18px 15px", width: "12%", textAlign: "center", borderBottom: "1px solid #52526C4D" }}>
                  <span style={{ opacity: "0.8" }}>{data.quantity}</span>
                </td>
                <td style={{ padding: "18px 15px", width: "12%", textAlign: "center", borderBottom: "1px solid #52526C4D" }}>
                  <span style={{ opacity: "0.8" }}>${data.price}</span>
                </td>
                <td style={{ padding: "18px 15px", width: "12%", textAlign: "center", borderBottom: "1px solid #52526C4D" }}>
                  <span style={{ opacity: "0.8" }}>${data.total}</span>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </td>
    </tr>
  );
};

export default InvoiceTable;
